import React, { useState } from 'react';
import api from '../utils/api';
import './AdminLogin.css';

const AdminLogin = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // Send password to backend for verification
      const response = await api.post('/api/admin/login', { password });
      
      if (response.data.success) {
        // Store authentication token in sessionStorage
        sessionStorage.setItem('adminToken', response.data.token);
        sessionStorage.setItem('adminAuthenticated', 'true');
        // Call success callback to update parent component
        onLoginSuccess();
      } else {
        setError('Invalid password. Please try again.');
      }
    } catch (err) {
      setError(
        err.response?.data?.error || 
        'Failed to authenticate. Please try again.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="login-header">
          <h1>Chalcedony Estate</h1>
          <h2>Admin Login</h2>
          <p>Enter your password to access the admin panel</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="alert alert-error">
              ✗ {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter admin password"
              autoFocus
              disabled={isLoading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary login-btn"
            disabled={isLoading || !password}
          >
            {isLoading ? 'Authenticating...' : 'Login'}
          </button>
        </form>

        <div className="login-footer">
          <a href="/" className="back-link">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;

